import { defineLocalStore } from '@/utils/localStore'
import { useRoute, useRouter } from 'vue-router'
import { axios, useBreadcrumb } from '@/plugins'
import { computed, ref } from 'vue'
import { cachedObject } from 'best-modules/utils'
import {
  urlProtocolSingle,
  urlProtocolUpdateDocument,
  urlProtocolUpdateExtraDocument,
  urlUpdateProtocol,
} from '@/utils/urls'
import { cloneDeep } from 'lodash'
import { handleAsync, setSnackbar } from 'best-modules/plugins'
import { Protocol } from '@/utils/types/protocol'
import { File } from '@/utils/types/helpers'
import { useCan } from '@/composables/useCan'

export const { useLocalStore: useProtocol, initLocalStore: initProtocol } =
  defineLocalStore('protocol', () => {
    const { can } = useCan()
    const route = useRoute()
    const router = useRouter()
    const breadcrumb = useBreadcrumb()
    const protocolId = computed<number>(() => {
      return Number(route.params.id)
    })
    const protocol = cachedObject<Protocol>({} as Protocol)
    const newFile = ref<File[] | null>(null)
    const disabled = computed<boolean>(() => {
      return !protocol.isActive || !can('protocols.update')
    })

    const getProtocol = () => {
      return handleAsync('protocolSingle', () => {
        return axios.get(urlProtocolSingle(route.params.id)).then(res => {
          if (res.data.status === 403) {
            router.replace({ name: 'protocol-list-all' })
          } else {
            breadcrumb.set([{ title: res.data.name, index: 1 }])
            protocol.$set(res.data)
          }
        })
      })
    }

    const protocolUpdate = (o = null) => {
      return handleAsync('protocolUpdate', () => {
        const req = cloneDeep(o || protocol.$object)
        req.document = newFile.value || req.document

        return axios.put(urlUpdateProtocol(protocolId.value), req).then(res => {
          protocol.$set(res.data)
          setSnackbar({ text: 'Протокол оновлено' })
        })
      })
    }

    const protocolUpdateDocument = () => {
      return handleAsync('protocolUpdateDocument', () => {
        return axios
          .patch(urlProtocolUpdateDocument(protocolId.value), {
            document: newFile.value,
          })
          .then(res => {
            protocol.$set(res.data)
            setSnackbar({ text: 'Протокол оновлено' })
          })
      })
    }
    const protocolUpdateExtraDocument = () => {
      return handleAsync('protocolUpdateExtraDocument', () => {
        return axios
          .patch(urlProtocolUpdateExtraDocument(protocolId.value), {
            extraDocuments: protocol.extraDocuments,
          })
          .then(res => {
            protocol.$set(res.data)
            setSnackbar({ text: 'Протокол оновлено' })
          })
      })
    }

    const protocolReset = () => {
      return protocol.$reset()
    }

    getProtocol()

    return {
      protocolId,
      protocol,
      newFile,
      disabled,
      protocolUpdate,
      protocolReset,
      protocolUpdateExtraDocument,
      protocolUpdateDocument,
    }
  })
